module.exports = __webpack_public_path__ + "img/ilustracion.74b18f60.svg";